import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3ccadca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a3ccadca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ccadca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ccadca')) {
      api.createRecord('a3ccadca', component.options)
    } else {
      api.reload('a3ccadca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3ccadca&scoped=true&", function () {
      api.rerender('a3ccadca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/login/index.vue"
export default component.exports